import {MenuProps, MobileMenu as PlatformMobileMenu, MobileMenuOption} from 'platform/components';

import {NumberedMenuItem} from '../NumberedMenu/NumberedMenuItem';

type MobileMenuProps = Pick<MenuProps, 'activeItemId' | 'onItemChange' | 'data-testid'> & {
  items: NumberedMenuItem[];
  placeholder?: string;
  isDisabled?: boolean;
};

export function MobileMenu(props: MobileMenuProps) {
  return (
    <PlatformMobileMenu
      data-testid={props['data-testid']}
      isDisabled={props.isDisabled}
      onClick={props.onItemChange}
      options={mapItemsToMobileMenuOptions(props.items)}
      placeholder={props.placeholder}
      value={props.activeItemId}
    />
  );
}

function mapItemsToMobileMenuOptions(items: NumberedMenuItem[]): MobileMenuOption[] {
  return items.map((item) => {
    if ('isDisabled' in item) {
      return {
        value: item.id,
        label: item.label,
        isDisabled: item.isDisabled,
      };
    }

    return {
      value: item.id,
      label: item.label,
    };
  });
}
